export function findParent(node, className) {
    let parent = node;
    while (!(parent.classList && parent.classList.contains(className)) &&
        parent.nodeName !== "BODY") {
        parent = parent.parentNode;
    }
    if (!parent.classList.contains(className)) {
        parent = null;
    }
    return parent;
}
